var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_ldWrap"},[_c('div',{staticClass:"_list"},_vm._l((_vm.allData.data),function(item,index){return _c('div',{key:index,staticClass:"_li"},[_c('div',{staticClass:"_cont"},[_c('img',{attrs:{"src":_vm.$IMG_URL + item.cover,"alt":""}}),_c('h4',[_vm._v(_vm._s(item.name))]),_c('p',[_vm._v(_vm._s(item.position))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }